<template>
  <base-layout>
    <template v-slot:header>
      <h1 class="text-3xl font-bold leading-tight text-gray-900">
        Evidentiranje prodaje preparata
      </h1>
      <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
        <div class="sm:col-span-3">
          <label for="pretraga" class="sr-only">Pretraga</label>
          <div class="relative">
            <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
              <!-- Heroicon name: solid/search -->
              <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
              </svg>
            </div>
            <input
                name="pretraga"
                id="pretraga"
                class="focus:ring-indigo-500 focus:border-indigo-500 block w-full rounded-md pl-10 sm:text-sm border-gray-300"
                placeholder="Pretraga"
                type="search"
                v-model="searchQuery"
            >
          </div>
        </div>
        <div class="sm:col-span-3">
          <label for="filter2" class="sr-only">Kategorija</label>
          <select
              id="filter2"
              name="filter"
              class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              v-model="category"
          >
            <option value="0">Sve kategorije</option>
            <option
                v-for="(category, index) in categories"
                :key="index"
                :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
        <div class="sm:col-span-3">
          <label for="filter" class="sr-only">Filter</label>
          <select
              id="filter"
              name="filter"
              class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              v-model="productStatus"
          >
            <option value="0">Svi</option>
            <option value="1">Prodati</option>
            <option value="2">Neprodati</option>
          </select>
        </div>
      </div>
    </template>
    <template v-slot:default>
      <div class="flex flex-col">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
                v-if="resultQuery && resultQuery.length"
            >
              <h3 class="p-0.5"> Prodaja: {{ promotion.activePromotion.products_total_sales }}/{{ promotion.activePromotion.products_target }}</h3>
              <table class="min-w-full divide-y divide-gray-200">
                <thead class="bg-gray-50">
                  <tr>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Naziv
                    </th>
                    <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      St./Pr.
                    </th>
                  </tr>
                </thead>
                <tbody class="bg-white divide-y divide-gray-200">
                <Product
                    v-for="(product, index) in resultQuery"
                    :key="index"
                    :name="product.name"
                    :id="product.bnr"
                    :minAmount="product.stock.initial_stock"
                    :amount="product.stock.counted_stock"
                    :image="product.images.thumbnail_url"
                    :sales="product.stock.sales"
                    :countedStock="product.stock.counted_stock"
                    @clicked="showModal"
                />
                </tbody>
              </table>
            </div>
            <div v-if="resultQuery && !resultQuery.length">
              <p class="mt-1 max-w-2xl text-sm text-gray-500">Nisu pronadjeni rezultati koji odgovaraju parametrima pretrage</p>
            </div>
          </div>
        </div>
      </div>
      <product-sales-modal
          v-if="modalShown"
          v-on:close-modal="modalShown = !modalShown"
          :name="clickedProduct.name"
          :bnr="clickedProduct.bnr"
          :amount="clickedProduct.stock.counted_stock"
          :minimum="clickedProduct.stock.counted_stock"
          :id="clickedProduct.id"
          :type="'product'"
          :sold="clickedProduct.stock.counted_stock"
          :image="clickedProduct.images.thumbnail_url"
          :realSales="clickedProduct.stock.sales"
      >
      </product-sales-modal>
    </template>
  </base-layout>
</template>

<script>
import ProductSales from './ProductSales';
export default ProductSales;
</script>
